module.exports = __webpack_public_path__ + "img/unequal.8f482102.png";